import React, { useEffect, useRef, useState } from 'react';
import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Grid,
    IconButton,
    Menu,
    MenuItem,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TextField,
    Select,
    MenuItem as MUIMenuItem,
    FormControl,
    InputLabel,
    Typography,
    List,
    ListItem,
    Pagination,
} from '@mui/material';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import dayjs from 'dayjs';
import { api } from 'src/_cores/_api/api';
import { showSuccess } from 'src/_cores/_reducers/alert.reducer';
import { useDispatch } from 'react-redux';
import GalleryDialog from 'src/_pages/product-detail/_components/dialog/prod-gallery';

interface IRate {
    id?: number;
    rateId?: number;
    rateValue?: number | null;
    value?: number | null;
    comment?: string;
    productId?: number | null;
    productName?: string | null;
    createDate?: string | Date | null;
    repliedId?: number | null;
    parentId?: number | null;
    htmlPosition?: string | null;
    userId?: number | null;
    userName?: string | null;
    userRepliedId?: number | null;
    idsToDelete?: string | null;
    images?: IRateImage[];
}

interface IRateImage {
    id: number;
    path?: string | null;
}

const defaultForm: IRate = {
    rateId: -1,
    rateValue: null,
    comment: '',
    productId: null,
    createDate: null,
    repliedId: null,
    parentId: null,
    htmlPosition: null,
    userId: null,
    userRepliedId: null,
    idsToDelete: null,
    images: [] as any[],
};

export default function RateList() {
    const [params, setParams] = useState<any>({
        searchKey: null,
        roleKey: null,
        pageIndex: 1,
        pageSize: 10,
        totalPage: 1,
    });
    const [rates, setRates] = useState<IRate[]>([]);
    const [open, setOpen] = useState(false);
    const [formData, setFormData] = useState<IRate>(defaultForm);
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const [menuRateId, setMenuRateId] = useState<number | null>(null);
    const [products, setProducts] = useState<any[]>([]);
    const [users, setUsers] = useState<any[]>([]);
    const uploadRef = useRef<any>(null);
    const [selectedImage, setSelectedImage] = useState("");
    const dispatch = useDispatch();


    useEffect(() => {
        fetchRates(params);
        // fetchProducts();
        // fetchUsers();
    }, []);

    const fetchRates = async (param: any) => {
        // TODO: replace endpoint with real one
        const res = await api.post('/comment/rate-paging', param) as any;
        if (res.isSucceed) {
            const data = res.data;
            setRates(data.items || []);
            setParams({
                ...param,
                pageIndex: res.data.pageIndex,
                totalPage: res.data.totalPages
            });
        }
    };

    const pageChange = (event: any, pageIndex: number) => {
        const _params = { ...params, pageIndex: pageIndex || 1 };
        setParams(_params);
        fetchRates(_params);
    }

    const onChangeInput = (type: 'searchKey' | 'voucher' | 'phoneNumber', event: any) => {
        const _params = { ...params, [type]: event?.target?.value || '' };
        setParams(_params);
    }

    const fetchProducts = async () => {
        // TODO: replace endpoint with real one
        const res = await fetch('/api/products/all') as any;
        if (res.isSucceed) {
            const data = await res.json();
            setProducts(data || []);
        }
    };

    const fetchUsers = async () => {
        // TODO: replace endpoint with real one
        const res = await fetch('/api/users?pageIndex=1&pageSize=1000') as any;
        if (res.isSucceed) {
            const data = await res.json();
            setUsers(data.items || []);
        }
    };

    const handleEdit = (r: IRate) => {
        setFormData({
            ...r,
            createDate: r.createDate ? new Date(r.createDate) : null,
        });
        setOpen(true);
    };

    const handleDelete = async (id?: number) => {
        if (window.confirm('Bạn có chắc chắn muốn xóa đánh giá này không?')) {
            const res = await api.post('/comment/delete?id=' + id) as any;
            if (res?.isSucceed) {
                dispatch(showSuccess('Xóa bình luận thành công!'));
                fetchRates(params);
            }
        }
    };

    const handleSubmit = async (e?: any) => {
        if (e && e.preventDefault) e.preventDefault();
        const payload: any = { ...formData };
        // ensure date type
        if (payload.createDate && !(payload.createDate instanceof Date)) {
            payload.createDate = new Date(payload.createDate);
        }

        if (formData.rateId && formData.rateId > -1) {
            // update
            // TODO: replace endpoint
            await fetch(`/api/rates/${formData.rateId}`, {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload),
            });
        } else {
            // create
            // TODO: replace endpoint
            const res = await fetch('/api/rates', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload),
            }) as any;
            const created = res.isSucceed ? await res.json() : null;
            if (created && uploadRef.current) {
                // upload images if any files selected
                // UploadInput should call onChangeFiles to return uploaded filenames, but if you need to upload here,
                // implement an upload call. Placeholder below:
                // await uploadRateImages(created.rateId);
            }
        }

        fetchRates(params);
        setOpen(false);
        uploadRef.current?.commitFiles?.();
    };

    const handleInputChange = (e: any) => {
        const { name, value, type, checked } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value,
        }));
    };

    // const handleUploadFilesChanged = (files: string[]) => {
    //     // files: array of uploaded file paths (UploadInput should return them)
    //     // attach to formData.images as needed
    //     const images = (files || []).map((p, idx) => ({
    //         ratingImageId: -Date.now() - idx,
    //         ratingImagePath: p,
    //     })) as IRateImage[];
    //     setFormData(prev => ({ ...prev, images: [...(prev.images || []), ...images] }));
    // };

    // const handleRemoveImage = async (img: IRateImage) => {
    //     // TODO: replace endpoint
    //     if (img.ratingImageId > 0) {
    //         await fetch(`/api/rates/images/${img.ratingImageId}`, { method: 'DELETE' });
    //     }
    //     setFormData(prev => ({ ...prev, images: (prev.images || []).filter(i => i.ratingImageId !== img.ratingImageId) }));
    // };

    const openMenu = (e: React.MouseEvent<HTMLElement>, rateId: number) => {
        setAnchorEl(e.currentTarget);
        setMenuRateId(rateId);
    };

    const closeMenu = () => {
        setAnchorEl(null);
        setMenuRateId(null);
    };

    return (
        <Box>
            <Grid container spacing={2} sx={{ marginBottom: 2 }}>
                <Grid item xs={12} sm={4}>
                    <TextField className="w-full" label="Tìm kiếm" placeholder="Nhập để tìm" size="small" onChange={(event: any) => onChangeInput('searchKey', event)} />
                </Grid>
                <Grid item xs={12} sm={4}>
                    <Button variant="contained" onClick={() => fetchRates(params)}>
                        Xem
                    </Button>
                </Grid>
            </Grid>
            <TableContainer component={Paper} sx={{ marginBottom: 2 }}>
                <Table size="small">
                    <TableHead>
                        <TableRow>
                            <TableCell>ID</TableCell>
                            <TableCell>Số sao</TableCell>
                            <TableCell>Bình luận</TableCell>
                            <TableCell>Sản phẩm</TableCell>
                            <TableCell>Người dùng</TableCell>
                            <TableCell>Ngày tạo</TableCell>
                            <TableCell align="center">Ảnh</TableCell>
                            <TableCell align="center">Hành động</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {rates.map(r => (
                            <TableRow key={r.id}>
                                <TableCell>{r.id}</TableCell>
                                <TableCell>{r.value}</TableCell>
                                <TableCell>
                                    <Typography noWrap>{r.comment}</Typography>
                                </TableCell>
                                <TableCell>{r.productName}</TableCell>
                                <TableCell>{r.userName}</TableCell>
                                <TableCell>{r.createDate ? dayjs(r.createDate).format('DD/MM/YYYY HH:mm') : ''}</TableCell>
                                <TableCell align="center">
                                    <div className="image images-comment mb-2">
                                        <ul className="image-list flex">
                                            {r.images && r.images.map((img: any, index: number) => (
                                                <li key={img.id} className="border" style={{ width: 128, marginRight: 2 }}>
                                                    <img
                                                        src={process.env.REACT_APP_IMAGE_URL + '/rates/' + img.path}
                                                        alt="Ảnh của bạn"
                                                        style={{ cursor: 'pointer' }}
                                                        onClick={() => {
                                                            setSelectedImage(process.env.REACT_APP_IMAGE_URL + '/rates/' + img.path);
                                                        }}
                                                    />
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                </TableCell>
                                <TableCell align="center">
                                    {/* <IconButton size="small" onClick={() => handleEdit(r)}>
                                        <ModeEditIcon />
                                    </IconButton> */}
                                    <IconButton size="small" onClick={() => handleDelete(r.id)}>
                                        <DeleteOutlineIcon />
                                    </IconButton>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
            <Pagination
                variant="outlined"
                shape="rounded"
                page={params.pageIndex}
                count={params.totalPage}
                onChange={pageChange}
            />

            <Dialog open={open} onClose={() => setOpen(false)} fullWidth maxWidth="md">
                <DialogTitle>{formData.rateId && formData.rateId > -1 ? 'Cập nhật đánh giá' : 'Thêm đánh giá'}</DialogTitle>
                <form onSubmit={handleSubmit}>
                    <DialogContent>
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={3}>
                                <FormControl fullWidth size="small">
                                    <InputLabel id="rate-value-label">Điểm</InputLabel>
                                    <Select
                                        labelId="rate-value-label"
                                        label="Điểm"
                                        name="rateValue"
                                        value={formData.rateValue ?? ''}
                                        onChange={(e) => setFormData(prev => ({ ...prev, rateValue: Number(e.target.value) }))
                                        }
                                    >
                                        {[1, 2, 3, 4, 5].map(v => <MUIMenuItem key={v} value={v}>{v}</MUIMenuItem>)}
                                    </Select>
                                </FormControl>
                            </Grid>

                            <Grid item xs={12} sm={4}>
                                <FormControl fullWidth size="small">
                                    <InputLabel id="product-label">Sản phẩm</InputLabel>
                                    <Select
                                        labelId="product-label"
                                        label="Sản phẩm"
                                        name="productId"
                                        value={formData.productId ?? ''}
                                        onChange={(e) => setFormData(prev => ({ ...prev, productId: e.target.value ? Number(e.target.value) : null }))
                                        }
                                    >
                                        <MUIMenuItem value="">-- Chọn sản phẩm --</MUIMenuItem>
                                        {products.map(p => <MUIMenuItem key={p.id} value={p.id}>{p.name || p.title || p.id}</MUIMenuItem>)}
                                    </Select>
                                </FormControl>
                            </Grid>

                            <Grid item xs={12} sm={5}>
                                <FormControl fullWidth size="small">
                                    <InputLabel id="user-label">Người dùng</InputLabel>
                                    <Select
                                        labelId="user-label"
                                        label="Người dùng"
                                        name="userId"
                                        value={formData.userId ?? ''}
                                        onChange={(e) => setFormData(prev => ({ ...prev, userId: e.target.value ? Number(e.target.value) : null }))
                                        }
                                    >
                                        <MUIMenuItem value="">-- Chọn người dùng --</MUIMenuItem>
                                        {users.map(u => <MUIMenuItem key={u.id} value={u.id}>{u.displayName || u.fullName || u.email || u.id}</MUIMenuItem>)}
                                    </Select>
                                </FormControl>
                            </Grid>

                            <Grid item xs={12}>
                                <TextField
                                    label="Bình luận"
                                    name="comment"
                                    fullWidth
                                    multiline
                                    minRows={3}
                                    value={formData.comment || ''}
                                    onChange={(e) => setFormData(prev => ({ ...prev, comment: e.target.value }))
                                    }
                                />
                            </Grid>
                            {/* 
                            <Grid item xs={12}>
                                <Typography variant="subtitle2" gutterBottom>Ảnh đánh giá</Typography>
                                <UploadInput
                                    ref={uploadRef}
                                    uploadType="rates"
                                    onChangeFiles={handleUploadFilesChanged}
                                    filesLimit={5}
                                />
                                <List>
                                    {(formData.images || []).map(img => (
                                        <ListItem key={img.ratingImageId} secondaryAction={
                                            <Button size="small" color="error" onClick={() => handleRemoveImage(img)}>Xóa</Button>
                                        }>
                                            <img src={img.ratingImagePath} alt="" style={{ height: 60, marginRight: 8 }} />
                                            <Typography noWrap>{img.ratingImagePath}</Typography>
                                        </ListItem>
                                    ))}
                                </List>
                            </Grid> */}
                        </Grid>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => { setOpen(false); uploadRef.current?.removeUncommittedFiles?.(); }}>Hủy</Button>
                        <Button type="submit" variant="contained">Lưu</Button>
                    </DialogActions>
                </form>
            </Dialog>

            <GalleryDialog
                selectedImage={selectedImage}
                openDialog={selectedImage !== ""}
                handleClickCloseDialog={() => setSelectedImage("")}
            />
        </Box>
    );
}